const cleanText = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

const possessiveName = (name = '') => cleanText(name).endsWith('s')
  ? `${cleanText(name)}'`
  : `${cleanText(name)}'s`;

const stripPreparationPrefix = (title = '') => cleanText(title)
  .replace(/^prepar(?:e|ing)\s+for\s+/i, '')
  .replace(/^your\s+/i, '')
  .replace(/^the\s+/i, '');

const withoutBriefSuffix = (title = '') => cleanText(title).replace(/\s+brief$/i, '');

const withBriefSuffix = (title = '') => {
  const cleaned = cleanText(title);
  return /\bbrief$/i.test(cleaned) ? cleaned : `${cleaned} Brief`;
};

export const formatBriefPreparedDate = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    month: 'long', day: 'numeric', year: 'numeric',
  }).format(date);
};

export const buildDefaultBriefTitle = ({ snapshot, personName }) => {
  const subject = stripPreparationPrefix(snapshot?.title || 'Meeting');
  if (!cleanText(personName)) return withBriefSuffix(subject);
  if (subject.toLowerCase().includes(cleanText(personName).toLowerCase())) return withBriefSuffix(subject);
  return withBriefSuffix(`${possessiveName(personName)} ${subject}`);
};

export const buildDefaultBriefPurpose = ({ snapshot }) => {
  const purpose = cleanText(snapshot?.journeyPlan?.purpose || snapshot?.purpose);
  if (purpose && purpose.length <= 120) return purpose;
  const subject = withoutBriefSuffix(stripPreparationPrefix(snapshot?.title || 'this meeting'));
  return `Prepared for ${subject.toLowerCase()}.`;
};

export const buildJourneyBriefHeader = ({
  snapshot, personName, preparedBy, overrides = {}, preparedAt = new Date(),
}) => {
  const safePersonName = cleanText(personName);
  const safePreparedBy = cleanText(preparedBy);
  const preparedOn = formatBriefPreparedDate(preparedAt);
  return {
    title: cleanText(overrides?.title) || buildDefaultBriefTitle({ snapshot, personName: safePersonName }),
    purpose: cleanText(overrides?.purpose) || buildDefaultBriefPurpose({ snapshot }),
    personName: safePersonName,
    preparedBy: safePreparedBy,
    preparedOn,
    trustStatement: safePreparedBy
      ? `Prepared with Lifelog from information reviewed and confirmed by ${safePreparedBy}.`
      : 'Prepared with Lifelog from information reviewed and confirmed by the caregiver.',
    footerText: `Caregiver-prepared and confirmed in Lifelog${preparedOn ? ` · Prepared ${preparedOn}` : ''}`,
  };
};

export const cleanEditableBriefHeader = (header = {}) => ({
  title: cleanText(header?.title),
  purpose: cleanText(header?.purpose),
});
